<template>
  <el-dialog
    :title="title"
    :visible.sync="isInfo"
    :close-on-click-modal="false"
    @close="close"
  >
    <el-form ref="fForm" :model="ruleForm" size="small" label-width="130px">
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group v-model="ruleForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group v-model="ruleForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group v-model="ruleForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" PC端是否展示：" required>
            <el-radio-group v-model="ruleForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="封面：">
            <div
              v-if="ruleForm.coverUrl"
              id="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer = true"
                ></i>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="图书名称：">
            <el-input readonly v-model="ruleForm.bookName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="图书来源：">
            <el-input readonly v-model="ruleForm.bookSource"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="图书作者：">
            <el-input readonly v-model="ruleForm.bookAuthor"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="图书分类：">
            <el-input readonly v-model="ruleForm.categoryName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="长简介：">
            <el-input readonly v-model="ruleForm.bookLongDesc"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[ruleForm.coverUrl]"
    />
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { bookInfo } from "@/api/book";
import { resCategoryTree } from "@/api/rescategory";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { getSysParamByTypes } from "@/api/sysParam";

export default {
  name: "detail",
  components: { ElImageViewer },
  data() {
    return {
      isInfo: false,
      title: "图书详情",
      categoryData: [],
      ruleForm: {
        coverUrl: "",
        bookName: "",
        bookSource: "",
        bookAuthor: "",
        categoryName: "",
        bookLongDesc: "",
        isApplet: "",
        isPc: "",
        isApp: "",
        isWeb: "",
      },
      showViewer: false,
      showCover: false,
      publicData: [],
    };
  },
  methods: {
    show(uuid) {
      bookInfo(uuid).then((res) => {
        if (!res || res.code !== 0) return;
        const item = res.data;
        this.ruleForm.coverUrl = item.coverUrl;
        this.ruleForm.bookName = item.bookName;
        this.ruleForm.bookSource = item.bookSource;
        this.ruleForm.bookAuthor = item.bookAuthor;
        this.ruleForm.categoryName = item.categoryName;
        this.ruleForm.bookLongDesc = item.bookLongDesc;
        this.ruleForm.isApp = item.isApp;
        this.ruleForm.isWeb = item.isWeb;
        this.ruleForm.isApplet = item.isApplet;
        this.ruleForm.isPc = item.isPc;
        this.isInfo = true;
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.publicData = res.data["IS_VALID"] || [];
      });
    },
    closeViewer() {
      this.showViewer = false;
    },
    close() {
      // 点击取消 数据重置
      this.isInfo = false;
    },
  },
  created() {
    this.getSysParamByTypes(["IS_VALID"]);
    // 获取视频分类数据
    resCategoryTree().then((res) => {
      if (!res || res.code !== 0) return;
      this.categoryData = res.data;
    });
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;

.avatar {
  width: 160px;
  height: 160px;
  display: block;
  object-fit: contain;
}

#video-output {
  width: 160px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
